import React from "react";
import { bulletIcon } from "../../../assets/icons";
import { Button } from "../../reusables";
import "./index.scss";

export default function SectionCard({
	data,
	noButton,
	fullTextWidth,
	bulletPoint,
}) {
	const fullTextWrapper = fullTextWidth && "w-100";

	return (
		<ul className="section-cards">
			{data?.map(
				({
					imageSource,
					heading,
					subHeading,
					description,
					eventDetails,
					link,
					linkText,
					id,
					imageClass,
				}) => (
					<li key={heading} className="section-card" id={id}>
						<div className="section-card-container">
							<div className="img-container">
								<img
									src={imageSource}
									alt="card-img"
									className={`card-image ${imageClass}`}
								/>
							</div>

							<div className="texts-container">
								<div className={`texts-wrapper`}>
									<p className="sub-heading mb-0">
										{subHeading && subHeading}
									</p>

									<h2>{heading}</h2>

									<ul className={fullTextWrapper}>
										{description?.map((desc) => (
											<li key={desc}>
												{bulletPoint && (
													<img
														src={bulletIcon}
														alt=""
													/>
												)}

												<p className="mb-0 text-justify">
													{desc}
												</p>
											</li>
										))}
									</ul>

									{eventDetails && (
										<div className="d-flex justify-content-between align-items-center w-100">
											<span>
												Date: <br /> {eventDetails.date}
											</span>
											<span>
												Duration: <br />
												{eventDetails.duration}
											</span>
											<span>
												Price:
												<br />
												{eventDetails.price}
											</span>
										</div>
									)}
									{noButton || (
										<Button linkTo={link && link} wide>
											{linkText || "Learn more"}
										</Button>
									)}
								</div>
							</div>
						</div>
					</li>
				)
			)}
		</ul>
	);
}
